import TtamMaterialModuleTitle from './title/index.vue';
import TtamMaterialSelect from './material-select/index.vue';
import TtamMaterialCatalogVpkgSelect from './catalog-vpkg-select/index.vue';

import TtamMaterialSelectUploadProgress from './material-upload-progress/index.vue';

import TtamMaterialDetail from './components/material-detail.vue';
import TtamMaterialEcho from './material-echo/index.vue';

import * as hooks from './hooks';

export default {
  ...hooks,
  TtamMaterialModuleTitle,
  TtamMaterialSelect,
  TtamMaterialCatalogVpkgSelect,

  TtamMaterialEcho,
  TtamMaterialSelectUploadProgress,

  TtamMaterialDetail,
};
